import {
  FOC_TOUR_LABEL_AI_IOC,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_AI_IOC_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  IOC_CARRYOVER_DISPOSITION,
  POST_FOC_DISPOSITION,
  focAiTourPopoverHtml,
  requirement,
  type FocAiTourStepDef,
} from './focAiTourTypes';

export const FOC_AI_IOC_TOUR_PARAM = 'focAiIocTour';
export const FOC_AI_IOC_TOUR_HREF = HREF;
export { focAiTourPopoverHtml };

export const FOC_AI_IOC_TOUR_STEPS: FocAiTourStepDef[] = [
  {
    id: 'sectionIntro',
    tour: 'pratus-ai-drawer',
    title: FOC_TOUR_LABEL_AI_IOC,
    description:
      'IOC carryover AI capabilities: access the assistant from any view, chat, grant incident workspace access, upload files, cite sources, and draft SITREPs with human review.',
  },
  requirement({
    id: 'ai001',
    requirementId: 'US-AI001',
    name: 'Access PRATUS AI',
    disposition: IOC_CARRYOVER_DISPOSITION,
    tour: 'pratus-ai-drawer',
    description:
      'Access the PRATUS AI Assistant interface from any view so you can ask questions and gain insights regardless of the current workflow.',
  }),
  requirement({
    id: 'ai002',
    requirementId: 'US-AI002',
    name: 'Chat with PRATUS AI',
    disposition: IOC_CARRYOVER_DISPOSITION,
    tour: 'pratus-ai-composer',
    description:
      'Send natural language queries to PRATUS AI and receive text-based responses for operational or general questions.',
  }),
  requirement({
    id: 'ai003',
    requirementId: 'US-AI003',
    name: 'Grant Access to Incident Workspaces',
    disposition: IOC_CARRYOVER_DISPOSITION,
    tour: 'pratus-ai-drawer',
    description:
      'Select one or more Incident Workspaces you can access and grant PRATUS AI permission to read their data for status, resources, or logs.',
  }),
  requirement({
    id: 'ai004',
    requirementId: 'US-AI004',
    name: 'Upload Files for Analysis',
    disposition: IOC_CARRYOVER_DISPOSITION,
    tour: 'pratus-ai-composer',
    description:
      'Upload documents (e.g., PDF, DOCX) to the chat context so PRATUS AI can analyze file contents and answer from that information.',
  }),
  requirement({
    id: 'ai005',
    requirementId: 'US-AI005',
    name: 'Enable Web Search',
    disposition: POST_FOC_DISPOSITION,
    description:
      'Toggle a Web Search option so PRATUS AI can retrieve real-time internet information. Not authorized without a Government decision.',
  }),
  requirement({
    id: 'ai006',
    requirementId: 'US-AI006',
    name: 'View Source Citations',
    disposition: IOC_CARRYOVER_DISPOSITION,
    tour: 'pratus-ai-sources',
    description: 'PRATUS AI cites its sources for generated answers.',
  }),
  requirement({
    id: 'ais001',
    requirementId: 'US-AIS001',
    name: 'Configure SITREP Data Sources',
    disposition: IOC_CARRYOVER_DISPOSITION,
    tour: 'reports-ai-generate',
    description:
      'Select which data sources PRATUS AI should analyze to generate a SITREP—including Incident Workspaces, uploaded files, and Web Search results when authorized.',
  }),
  requirement({
    id: 'ais002',
    requirementId: 'US-AIS002',
    name: 'Provide Custom Generation Instructions',
    disposition: IOC_CARRYOVER_DISPOSITION,
    tour: 'reports-ai-generate',
    description:
      'Provide natural language instructions so the generated SITREP is tailored to immediate reporting needs.',
  }),
  requirement({
    id: 'ais003',
    requirementId: 'US-AIS003',
    name: 'Generate AI SITREP Draft',
    disposition: IOC_CARRYOVER_DISPOSITION,
    tour: 'reports-ai-generate',
    description:
      'Trigger automatic generation of a SITREP draft that synthesizes selected real-time data into a structured narrative baseline.',
  }),
  requirement({
    id: 'ais004',
    requirementId: 'US-AIS004',
    name: 'Edit AI-Generated Content',
    disposition: IOC_CARRYOVER_DISPOSITION,
    tour: 'reports-ai-generate',
    description:
      'Manually edit AI-generated SITREP text to correct inaccuracies, refine tone, or add sensitive information not present in the data sources.',
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_AI_IOC),
  },
];

export function focAiIocTourNavVisible(enabled: boolean): boolean {
  return enabled;
}

export function focAiIocTourStepIds(): string[] {
  return FOC_AI_IOC_TOUR_STEPS.map((step) => step.id);
}
